import { alpha } from '@mui/system';
import { colors } from '../constants';
const styleOverrides = {
  root: {
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(2px)',
    background: alpha(colors.commonColors.black, 0.2)
  },
  invisible: {
    backdropFilter: 'unset',
    WebkitBackdropFilter: 'unset'
  }
};
export default {
  styleOverrides
};